import type { ReactNode } from 'react'

import { comicCanvasScrollShellClass, comicCanvasScrollTrackClass } from '../../lib/comicCanvasChrome'
import { ScrollRegion } from '../ScrollRegion'
import { comicEditorSelectClass } from './comicPanelTokens'

type Props = {
  children: ReactNode
  className?: string
}

/**
 * 漫画画布唯一纵向滚动骨架：话次块与吸顶标题均须为其子节点。
 * 勿在此外层使用 transform（会破坏 sticky）。
 */
export function ComicEpisodeCanvasScrollShell({ children, className }: Props) {
  return (
    <ScrollRegion
      className={[comicCanvasScrollShellClass(), comicEditorSelectClass(), className]
        .filter(Boolean)
        .join(' ')}
    >
      <div className={comicCanvasScrollTrackClass}>{children}</div>
    </ScrollRegion>
  )
}
